import _get from 'lodash/get';

export default (data) => {
  const { suppliers, searchRef } = data;

  const rates = _get(data, 'rates', [])
    .filter((rate) => !(!rate.payNow && !rate.payLater)) // in case the server has failed to return both amounts
    .map((rate, id) => {
      const { src, search, supplierId } = rate;

      const provider = _get(suppliers, `${src}:${supplierId}`, {});

      /*
       * server's "key" prop => "searchPosition"
       * for convenience ( React has the same required prop on its components )
       * */
      const searchPosition = rate.key;
      const { key, ...restRate } = rate;

      return {
        ...restRate,
        id,
        searchPosition,
        transmission: restRate.automatic ? 'A' : 'M',
        searchId: _get(searchRef, [`${src}:${search}`, 'key']),
        size: restRate.oldSize,
        providerName: provider.name,
        providerLogoURL: provider.logo,
      };
    });

  return {
    ...data,
    rates,
  };
};
